import React from 'react';

type Props = {
  className?: string;
  size?: number;
};

const Icon: React.FC<Props> = ({
  className,
  size = 24,
}: Props) => (
<svg
  data-ffid='icn-wishlist-unfilled'
  className={className}
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
<path d="M12 21.175L10.55 19.875C8.86702 18.358 7.47502 17.05 6.37502 15.95C5.27502 14.85 4.40002 13.862 3.75002 12.987C3.10002 12.112 2.64602 11.308 2.38702 10.574C2.12802 9.83997 1.99902 9.09098 1.99902 8.32398C1.99902 6.75698 2.52402 5.44897 3.57402 4.39897C4.62402 3.34897 5.93202 2.82397 7.49902 2.82397C8.36602 2.82397 9.19102 3.00697 9.97402 3.37397C10.757 3.74097 11.432 4.25697 11.999 4.92397C12.566 4.25697 13.241 3.74097 14.024 3.37397C14.807 3.00697 15.632 2.82397 16.499 2.82397C18.066 2.82397 19.374 3.34897 20.424 4.39897C21.474 5.44897 21.999 6.75698 21.999 8.32398C21.999 9.09098 21.87 9.84098 21.611 10.574C21.352 11.307 20.898 12.112 20.248 12.987C19.598 13.862 18.723 14.85 17.623 15.95C16.523 17.05 15.131 18.358 13.448 19.875L11.998 21.175H12ZM12 18.475C13.6 17.042 14.917 15.812 15.95 14.787C16.983 13.762 17.8 12.87 18.4 12.112C19 11.354 19.417 10.679 19.65 10.087C19.883 9.49497 20 8.90798 20 8.32398C20 7.32398 19.667 6.49097 19 5.82397C18.333 5.15697 17.5 4.82397 16.5 4.82397C15.717 4.82397 14.992 5.04497 14.325 5.48697C13.658 5.92897 13.2 6.49097 12.95 7.17497H11.05C10.8 6.49197 10.342 5.92897 9.67502 5.48697C9.00802 5.04497 8.28302 4.82397 7.50002 4.82397C6.50002 4.82397 5.66702 5.15697 5.00002 5.82397C4.33302 6.49097 4.00002 7.32398 4.00002 8.32398C4.00002 8.90698 4.11702 9.49497 4.35002 10.087C4.58302 10.679 5.00002 11.354 5.60002 12.112C6.20002 12.87 7.01702 13.762 8.05002 14.787C9.08302 15.812 10.4 17.041 12 18.475Z"
  className="fill-gray-light-gray dark:fill-white" />
</svg>

);

export default Icon;
